import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Col, Form, Row, Modal, Button, Image } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import {
  ORDER_TYPE_NAME,
  ITEMTYPEVEG,
  DELIVERY_TYPES,
  FLAT_CHARGE_KEYS,
} from "../../enums/OrderEnums";
import InfoToolTip from "../../components/reusableComponents/InfoTooltipComponent";
import { getFlatCharges } from "../../function/getFlatCharges";
import isEmpty from "../../store/validation/is-Empty";
import Alert from "react-s-alert";

import {
  calcDiscount,
  calcFinalTotal,
  calcTotalOriginal,
} from "../../function/ordering";
import { getPendingPayment } from "../../function/getPendingPayment";

const CashModal = (props) => {
  const [userData, setUserData] = useState();
  const [cartData, setCartData] = useState();
  const [pendingAmount, setPendingAmount] = useState(false);
  const [offerData, setOfferData] = useState();
  const [summary, setSummary] = useState({});
  const subscriptionData = useSelector((state) => {
    return !isEmpty(state?.onboarding?.onboard_subscription_details)
      ? state?.onboarding?.onboard_subscription_details
      : "";
  });

  const exitingOrder = useSelector((state) =>
    !isEmpty(state.vendorOrdering.vendor_order_data)
      ? state.vendorOrdering.vendor_order_data
      : ""
  );


  useEffect(() => {
    setCartData(props?.cartData);
    setUserData(props?.userData);
    setOfferData(props?.offerData);
    let summary = calcFinalTotal(
      props?.cartData,
      props?.userData,
      props?.offerData,
      props?.subscriptionData
    );
    setSummary(summary);
  }, [
    props?.cartData,
    props?.userData,
    props?.offerData,
    props?.subscriptionData,
  ]);

  const [cash, setCash] = useState("");
  const [cashError, setCashError] = useState(false);
  const [remaining, setRemaining] = useState(0);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  const handleCash = (e) => {
    if (
      /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/.test(parseFloat(e.target.value))
    ) {
      setCash(e.target.value);
      setCashError(false);
      setPendingAmount(false);
      setRemaining((parseFloat(e.target.value) - props?.total).toFixed(2));
    } else {
      setCashError(true);
      setPendingAmount(true);
      setCash("");
      setRemaining(0);
    }
  };

  const calcTotal = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
      itemPrice.push(data[i][0].finalPrice * data[i][0].quantity);
    }
    if (userData && userData?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (userData && userData?.isPercentage) {
        let offerDiscount =
          offerData &&
          offerData.find(
            (e) => e.coupon_code === userData && userData?.coupon_code
          );
        let totalPercentage = (
          (totalPrice * userData && userData?.discountAmount) / 100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
      } else {
        discount = userData && userData?.discountAmount;
      }
    }
    return (price - discount).toFixed(2);
  };

  const calcTotalOriginal = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
      itemPrice.push(data[i][0].finalPrice * data[i][0].quantity);
    }
    return price.toFixed(2);
  };


  const onClickDoneButton = () => {
    // Alert.error(`<h4>Please Pay Pending Amount</h4>`, {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
    setPendingAmount(true);
  };

  const calcTaxes = (data) => {
    let tax = Object.values(data).reduce(
      (a, b) => parseFloat(a || 0) + parseFloat(b || 0),
      0
    );
    return tax.toFixed(2);
  };
  return (
    <React.Fragment>
      <Modal
        show={true}
        onHide={props.hideModal}
        centered
        size="md"
        backdrop="static"
      >
        <Modal.Header
          className="border-0 d-block"
          style={{ backgroundColor: "#fff2d5" }}
        >
          <div className="col-12 d-flex align-items-center mb-3">
            <h5 className="f11-400">{props?.events ? "Event" : "Order"} ID:</h5>
            <p className="f11-500 mr-4 ml-1 text-red">
              {userData &&
              userData?.order_id !== null &&
              userData &&
              userData?.order_id !== undefined &&
              userData &&
              userData?.order_id !== ""
                ? userData && userData?.order_id
                : "N/A"}
            </p>
            <span
              className="badge badge-warning px-3 py-1"
              style={{ borderRadius: 25 }}
            >
              {" "}
              {props?.events
                ? userData?.event_type
                : ORDER_TYPE_NAME[userData?.order_type]}
            </span>
          </div>
          <div className="col-12 f20-700 mb-1">
            {userData?.user_details?.first_name +
              " " +
              userData?.user_details?.last_name || ""}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row
            className="f12-500 align-items-center px-3 pb-3"
            style={{ backgroundColor: "#ffffff" }}
          >
            <Col xs={12} sm={12} md={12}>
              <TextField
                label="Enter received amount"
                variant="outlined"
                type="number"
                className={`w-100  ${cashError ? "enError" : ""}`}
                onInput={maxLengthCheck}
                inputProps={{ maxLength: 10 }}
                // onKeyPress={(event) => {
                //   if (!/[0-9]/.test(event.key)) {
                //     event.preventDefault();
                //   }
                // }}
                name="reference"
                value={cash}
                onChange={handleCash}
              />
              {pendingAmount ? (
                <div className="f10-700 text-danger mt-2">
                  Please Pay Pending Amount
                </div>
              ) : null}
            </Col>
            {/* {!props?.events && ( */}
            <Col xs={12} sm={12} md={12} className="f12-500">
              <h5 className="f14-400 mt-3 mb-2">
                {props?.events ? "Event" : "Order"} Details
              </h5>
              {cartData &&
                cartData.map((data, index) => {
                  return (
                    <Row key={index} className="align-items-center pt-3 pb-2">
                      <Col
                        xs={5}
                        sm={5}
                        md={5}
                        className="d-flex align-items-center text-left"
                      >
                        {ITEMTYPEVEG.map((type, index) => {
                          return (
                            <React.Fragment key={index}>
                              {data && data[0]?.itemType === type?.value ? (
                                <Image
                                  width="15px"
                                  height="15px"
                                  src={type.url}
                                  alt={type.title}
                                  title={type.title}
                                  fluid
                                />
                              ) : null}
                            </React.Fragment>
                          );
                        })}

                        <h5 className="f11-400 opacity5 ml-2">
                          {data[0]?.item?.name}
                        </h5>
                      </Col>
                      <Col xs={2} sm={2} md={2} className="text-center">
                        <h5 className="f11-500 opacity5">
                          {data[0]?.quantity}
                        </h5>
                      </Col>
                      <Col xs={5} sm={5} md={5} className="text-right">
                        <h5 className="f11-700">
                          ₹ {data[0]?.finalPrice * data[0]?.quantity}
                        </h5>
                      </Col>
                    </Row>
                  );
                })}
              {props?.events && (
                <Row className="align-items-center pt-3 pb-2">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f11-400 opacity5 ml-2">Donation</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f11-700">
                      ₹ {userData && userData?.donation?.amount.toFixed(2)}
                    </h5>
                  </Col>
                </Row>
              )}
            </Col>
            {/* )} */}
          </Row>
          <Row className="py-3 px-3" style={{ backgroundColor: "#f9f9f9" }}>
            <Col xs={12} sm={12} md={12}>
              <Row>
                <Col className="text-left">
                  <h5 className="f11-400 opacity5">Sub Total</h5>
                </Col>
                <Col className="text-right">
                  <h5 className="f11-700">
                    ₹{" "}
                    {props?.events ? (
                      <>{props?.total || ""}</>
                    ) : (
                      <>
                        {cartData && cartData.length > 0
                          ? calcTotalOriginal(cartData)
                          : userData?.base_amount !== null &&
                            userData?.base_amount !== undefined
                          ? userData?.base_amount?.toFixed(2)
                          : 0}
                      </>
                    )}
                  </h5>
                </Col>
              </Row>
            </Col>
          </Row>
          {!props?.events && (
            <Row className="p-3">
              <Col xs={12} sm={12} md={12}>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f11-400 opacity5 mr-1">Discount</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f11-700">
                      {userData && userData.isOfferApplied ? (
                        <>₹{userData?.discount?.amount}</>
                      ) : (
                        <> ₹0.00</>
                      )}
                    </h5>
                  </Col>
                </Row>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f11-400 opacity5 mr-1">Taxes</h5>
                    {!isEmpty(exitingOrder) &&
                    !exitingOrder?.total_amount
                      ? summary?.taxes?.gstTotal && (
                          <InfoToolTip
                            title={"Taxes"}
                            hover={true}
                            data={summary?.taxes?.gst || {}}
                          />
                        )
                      : exitingOrder?.gstAmount && (
                          <InfoToolTip
                            title={"Taxes"}
                            hover={true}
                            data={exitingOrder?.gstAmount || {}}
                          />
                        )}
                  </Col>
                  <Col className="text-right">
                    <h5 className="f11-700">
                      {!isEmpty(exitingOrder) &&
                      !exitingOrder?.total_amount ? (
                        summary?.taxes?.gstTotal > 0 ? (
                          <>₹{summary?.taxes?.gstTotal.toFixed(2)}</>
                        ) : (
                          <> ₹0.00</>
                        )
                      ) : exitingOrder?.gstAmount ? (
                        <>{calcTaxes(exitingOrder?.gstAmount)}</>
                      ) : (
                        <> ₹0.00</>
                      )}
                    </h5>
                  </Col>
                </Row>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f11-400 opacity5">Surcharges</h5>
                    {!isEmpty(exitingOrder) &&
                    !exitingOrder?.total_amount
                      ? summary?.taxes?.surTotal && (
                          <InfoToolTip
                            title={"SurCharges"}
                            hover={true}
                            data={summary?.taxes?.surCharges || {}}
                          />
                        )
                      : exitingOrder?.surCharges && (
                          <InfoToolTip
                            title={"Taxes"}
                            hover={true}
                            data={exitingOrder?.surCharges || {}}
                          />
                        )}
                  </Col>
                  <Col className="text-right">
                    <h5 className="f11-700">
                      {!isEmpty(exitingOrder) &&
                      !exitingOrder?.total_amount ? (
                        summary?.taxes?.surTotal > 0 ? (
                          <>₹{summary?.taxes?.surTotal.toFixed(2)}</>
                        ) : (
                          <> ₹0.00</>
                        )
                      ) : exitingOrder?.surCharges ? (
                        <>{calcTaxes(exitingOrder?.surCharges)}</>
                      ) : (
                        <> ₹0.00</>
                      )}
                    </h5>
                  </Col>
                </Row>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f11-400 opacity5">Tips</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f11-700">
                      ₹{(userData?.tip?.amount || 0).toFixed(2)}
                    </h5>
                  </Col>
                </Row>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f11-400 opacity5">Donation</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f11-700">
                      ₹ {(userData?.donation?.amount || 0).toFixed(2)}
                    </h5>
                  </Col>
                </Row>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f18-700">Total :</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f18-700">
                      {!isEmpty(exitingOrder) &&
                      !exitingOrder?.total_amount ? (
                        summary?.total > 0 ? (
                          <>₹ {summary?.total}</>
                        ) : (
                          <> ₹0.00</>
                        )
                      ) : (
                        <>
                          ₹&nbsp;
                          {!getPendingPayment(exitingOrder) &&
                          exitingOrder?.total_amount !== null &&
                          exitingOrder?.total_amount !== undefined
                            ? exitingOrder?.total_amount
                            : getPendingPayment(exitingOrder)}{" "}
                        </>
                      )}
                    </h5>
                  </Col>
                </Row>
                <Row className="pb-3">
                  <Col className="text-left d-flex align-items-center">
                    <h5 className="f18-700">Amount Received :</h5>
                  </Col>
                  <Col className="text-right">
                    <h5 className="f18-700">₹ {cash !== "" ? cash : 0}</h5>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {props?.events && (
            <>
              <Row className="p-3">
                <Col xs={12} sm={12} md={12}>
                  <Row className="pb-3">
                    <Col className="text-left d-flex align-items-center">
                      <h5 className="f18-700">Amount Received :</h5>
                    </Col>
                    <Col className="text-right">
                      <h5 className="f18-700">₹ {cash !== "" ? cash : 0}</h5>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
          <Row className="py-3 px-3" style={{ backgroundColor: "#fff2d5" }}>
            <Col xs={12} sm={12} md={12}>
              <Row>
                <Col className="text-left">
                  <h5 className="f15-700">
                    {remaining > 0
                      ? "Amount To Be Returned"
                      : remaining < 0
                      ? "Pending Amount"
                      : "Amount To Be Returned"}{" "}
                    :
                  </h5>
                </Col>
                <Col className="text-right">
                  <h5 className={`f18-700 ${remaining < 0 ? "text-red" : ""}`}>
                    ₹ {Math.abs(remaining)}
                  </h5>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="px-3 pt-3 justify-content-center">
            <div className="col-5">
              <Button
                variant="outline-secondary"
                className="btn-md py-2"
                style={{ width: "90%" }}
                onClick={props.hideModal}
              >
                Cancel
              </Button>
            </div>
            <div className="col-5">
              <Button
                variant="danger"
                className="btn-md py-2 w-100"
                onClick={
                  parseInt(cash) < parseInt(props?.total)
                    ? onClickDoneButton
                    : props.hideModal
                }
                disabled={parseInt(cash) === 0 || cash === "" ? true : false}
              >
                Done
              </Button>
            </div>
          </Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default CashModal;
